export default "__VITE_PUBLIC_ASSET__bd2cd1a6__"